import React, { Component } from "react";
import { Link } from "react-router-dom";
import { getCountries, getStates, getLanguages, register } from "../../../data-service";
import { validateEmail, emptyCheck, validatePassword } from "../../../utilities";
import Spinner from "../../User/Common/Spinner/Spinner";

class RegisterContainer extends Component {
  state = {
    error: false,
    errorMessage: "",
    success: false,
    successMessage: "",
    countries: [],
    languages: [],
    states: [],
    statesByCountry: [],
    showSpinner: false
  };

  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow
    });
  }

  getCountriesForR() {
    this.showSpinner(true);
    let arrCountries = [];
    getCountries()
      .then(response => {
        this.showSpinner(false);
        for (let country of response.data) {
          arrCountries.push(
            <option key={country.Id} value={country.Id}>
              {country.Name}
            </option>
          );
        }
        this.setState({ countries: arrCountries });
      })
      .catch(error => {
        this.showSpinner(false);
        this.setState({
          error: true,
          errorMessage:
            error.request.response === ""
              ? "Request was made but no response received. Please try after sometime or contact administrator"
              : ""
        });
      });
  }

  getStatesForR() {
    this.showSpinner(true);
    let arrStates = [];
    getStates()
      .then(response => {
        this.showSpinner(false);
        for (let state of response.data) {
          arrStates.push(state);
        }
        this.setState({ states: arrStates });
      })
      .catch(error => {
        this.showSpinner(false);
        this.setState({
          error: true,
          errorMessage:
            error.request.response === ""
              ? "Request was made but no response received. Please try after sometime or contact administrator"
              : ""
        });
      });
  }

  getLanguagesForR() {
    let arrLanguages = [];
    this.showSpinner(true);
    getLanguages()
      .then(response => {
        this.showSpinner(false);
        for (let language of response.data) {
          arrLanguages.push(
            <option key={language.Id} value={language.Id}>
              {language.Name}
            </option>
          );
        }
        this.setState({ languages: arrLanguages });
      })
      .catch(error => {
        this.showSpinner(false);
        this.setState({
          error: true,
          errorMessage:
            error.request.response === ""
              ? "Request was made but no response received. Please try after sometime or contact administrator"
              : ""
        });
      });
  }
  countryChanged(event) {
    let arrStates = [];
    let states = this.state.states.filter(d => d.CountryId === parseInt(event.target.value, 10));
    for (let state of states) {
      arrStates.push(
        <option key={state.Id} value={state.Id}>
          {state.Name}
        </option>
      );
    }
    this.setState({ statesByCountry: arrStates });
  }
  componentDidMount() {
    this.getCountriesForR();
    this.getStatesForR();
    this.getLanguagesForR();
  }
  focusElement(name) {
    this.refs[name].focus();
  }

  validate(name, email, countryId, stateId, languageId, password, confirmPassword) {
    if (emptyCheck(name)) {
      this.setState({ error: true, errorMessage: "Please enter your name" });
      this.focusElement("inputName");
      return false;
    } else if (emptyCheck(email)) {
      this.setState({ error: true, errorMessage: "Please enter your email" });
      this.focusElement("inputSignupEmail");
      return false;
    } else if (emptyCheck(password)) {
      this.setState({ error: true, errorMessage: "Please enter password" });
      this.focusElement("inputSignupPassword");
      return false;
    } else if (emptyCheck(confirmPassword)) {
      this.setState({ error: true, errorMessage: "Please confirm your password" });
      this.focusElement("inputConPassword");
      return false;
    } else if (!validateEmail(email)) {
      this.setState({ error: true, errorMessage: "Please enter a valid email address" });
      this.focusElement("inputSignupEmail");
      return false;
    } else if (countryId === -1) {
      this.setState({ error: true, errorMessage: "Please select a country" });
      this.focusElement("inputCountry");
      return false;
    } else if (stateId === -1) {
      this.setState({ error: true, errorMessage: "Please select a state" });
      this.focusElement("inputState");
      return false;
    } else if (languageId === -1) {
      this.setState({ error: true, errorMessage: "Please select a preferred language" });
      this.focusElement("inputLanguage");
      return false;
    } else if (!validatePassword(password)) {
      this.setState({
        error: true,
        errorMessage:
          "Please must contain at least one number, one lowercase and one uppercase letter. Atleast 6 characters required"
      });
      this.focusElement("inputSignupPassword");
      return false;
    } else if (password !== confirmPassword) {
      this.setState({ error: true, errorMessage: "Password and confirm password should be same" });
      this.focusElement("inputSignupPassword");
      this.focusElement("inputConPassword");
      return false;
    } else {
      this.setState({ error: false, errorMessage: "" });
      return true;
    }
  }

  signUp() {
    const name = this.refs["inputName"].value;
    const email = this.refs["inputSignupEmail"].value;
    const countryId = parseInt(this.refs["inputCountry"].value, 10);
    const stateId = parseInt(this.refs["inputState"].value, 10);
    const languageId = parseInt(this.refs["inputLanguage"].value, 10);
    const password = this.refs["inputSignupPassword"].value;
    const confirmPassword = this.refs["inputConPassword"].value;
    if (this.validate(name, email, countryId, stateId, languageId, password, confirmPassword)) {
      this.showSpinner(true);
      let data = {
        Email: email,
        Password: password,
        ConfirmPassword: confirmPassword,
        LanguageId: languageId,
        CountryId: countryId,
        StateId: stateId,
        Name: name
      };
      register(data)
        .then(response => {
          this.refs["inputName"].value = "";
          this.refs["inputSignupEmail"].value = "";
          this.refs["inputCountry"].value = -1;
          this.refs["inputState"].value = -1;
          this.refs["inputLanguage"].value = -1;
          this.refs["inputSignupPassword"].value = "";
          this.refs["inputConPassword"].value = "";
          this.showSpinner(false);
          this.setState({
            success: true,
            successMessage: "Registration successful! Please verify your email address in order to login."
          });
        })
        .catch(error => {
          this.showSpinner(false);
          this.setState({
            error: true,
            errorMessage:
              error.request.response === ""
                ? "Request was made but no response received. Please try after sometime or contact administrator"
                : error.response.data.ModelState
                  ? error.response.data.ModelState[""][0]
                  : ""
          });
        });
    }
  }
  render() {
    let errorPlaceholder = null;
    if (this.state.error) {
      errorPlaceholder = <p className="alert alert-danger text-center">{this.state.errorMessage}</p>;
    }
    if (this.state.success) {
      errorPlaceholder = <p className="alert alert-success text-center">{this.state.successMessage}</p>;
    }

    return (
      <div className="card card-container" id="signupbox">
        <Spinner showSpinner={this.state.showSpinner} />
        {errorPlaceholder}
        <form className="form-signin">
          <input type="text" maxLength="50" ref="inputName" className="form-control" placeholder="Name" />
          <input
            type="email"
            maxLength="40"
            ref="inputSignupEmail"
            className="form-control mar-bot-10"
            placeholder="Email"
          />
          <select ref="inputCountry" className="form-control" onChange={event => this.countryChanged(event)}>
            <option value={-1}>Select Country</option>
            {this.state.countries}
          </select>
          <select ref="inputState" className="form-control">
            <option value={-1}>Select State</option>
            {this.state.statesByCountry}
          </select>
          <select ref="inputLanguage" className="form-control">
            <option value={-1}>Select preferred language</option>
            {this.state.languages}
          </select>
          <input type="password" ref="inputSignupPassword" className="form-control" placeholder="Password" />
          <input type="password" ref="inputConPassword" className="form-control" placeholder="Confirm Password" />

          <button type="button" className="btn btn-lg btn-primary btn-block btn-signin" onClick={() => this.signUp()}>
            Sign up
          </button>
          <Link to="/login">Sign In</Link>
        </form>
      </div>
    );
  }
}

export default RegisterContainer;



// WEBPACK FOOTER //
// ./src/containers/Login/RegisterContainer/RegisterContainer.js